import { render, staticRenderFns } from "./CollectionFilterControlTypeRelationship.vue?vue&type=template&id=8896a538"
import script from "./CollectionFilterControlTypeRelationship.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeRelationship.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports